import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d629363"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OkInvoiceHeader" }
const _hoisted_2 = { class: "OkInvoiceHeader__main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0.939341 10.9393C0.353554 11.5251 0.353554 12.4749 0.939341 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.939341 10.9393ZM22 10.5L2 10.5V13.5L22 13.5V10.5Z",
  fill: "black",
  "fill-opacity": "0.6"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "main__title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex item-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ok_input = _resolveComponent("ok-input")!
  const _component_ok_modal = _resolveComponent("ok-modal")!
  const _component_ok_button = _resolveComponent("ok-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state_date.is_open)
      ? (_openBlock(), _createBlock(_component_ok_modal, {
          key: 0,
          title: "Перенос даты забора",
          class: "OkModal-medium",
          "confirm-button-text": "Сохранить",
          "cancel-button-text": "Отмена",
          disabled: _ctx.state_date.is_loading,
          loading: _ctx.state_date.is_loading,
          onConfirm: _ctx.confirmDate,
          onCancel: _ctx.closeDate
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ok_input, {
              name: "Укажите дату",
              placeholder: "Укажите дату",
              type: "datetime-local",
              value: _ctx.state_date.date,
              "is-invalid": _ctx.state_date_form$.date.$error,
              "validation-errors": _ctx.state_date_form$.date.$errors,
              "onUpdate:value": _ctx.onDateChanged
            }, null, 8, ["value", "is-invalid", "validation-errors", "onUpdate:value"])
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onConfirm", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("svg", {
        class: "cursor-pointer",
        width: "22",
        height: "24",
        viewBox: "0 0 22 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onGoBack && _ctx.onGoBack(...args)))
      }, _hoisted_4)),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isEdit)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Редактировать накладную"))
          : _createCommentVNode("", true),
        _createTextVNode(" №" + _toDisplayString(_ctx.invoiceNumber), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_ok_button, {
        type: "button",
        class: "OkButton--blue",
        onClick: _ctx.openDate
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Перенести дату доставки ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      (!_ctx.isEdit)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/oktell/clients/invoices/${_ctx.invoice_id}/edit`,
            class: "ml-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ok_button, {
                type: "button",
                class: "OkButton--blue"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ])
  ]))
}